var current_state = false;
var mElement = null;
var mContainer = null;

const updateUI = () => {
	if (mContainer) {
		mContainer.classList.remove('show_hamburger');

		if (current_state) {
			mContainer.classList.add('show_hamburger');
		}

		if (mElement) {
			mElement.classList.remove('is-active');

			if (current_state) {
				mElement.classList.add('is-active');
			}
		}
	}
}

const change = () => {
	current_state = !current_state;
	updateUI();
}

const install = (vue) => {
	vue.directive('hamburger-toggler', {
		bind(el) {
			el.addEventListener('click', () => {
				mElement = el;
				change();
			});
		}
	});

	vue.directive('hamburger-container', {
		bind(el) {
			mContainer = el;
		}
	});

	vue.directive('hamburger-link', {
		bind(el) {
			el.addEventListener('click', () => {
				if (current_state) {
					change();
				}
			});
		}
	});
};

export default install;